import { VisualizerFind } from './types';

export interface VisualizerFindSource {
  id: string;
  longitude?: number | string | null;
  latitude?: number | string | null;
  type?: string | null;
  era?: string | null;
  material?: string | null;
  tags?: string[] | null;
  draft?: boolean;
}

export function normalizeVisualizerFind(
  find: VisualizerFindSource
): VisualizerFind | null {
  if (find.longitude == null || find.latitude == null) {
    return null;
  }

  const longitude = Number(find.longitude);
  const latitude = Number(find.latitude);
  if (!Number.isFinite(longitude) || !Number.isFinite(latitude)) {
    return null;
  }

  return {
    id: find.id,
    longitude,
    latitude,
    type: find.type,
    era: find.era,
    material: find.material,
    tags: find.tags || [],
    draft: find.draft,
  };
}
